module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-box"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('customer-search-form', {
    attrs: {
      "values": _vm.form,
      "watchValues": true
    },
    on: {
      "loading": _vm.handleLoading,
      "loaded": _vm.handleLoaded
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "col-md-12"
  }, [_c('customers-table', {
    attrs: {
      "customers": _vm.models.customers,
      "pagination": _vm.models.pagination
    },
    on: {
      "changePage": _vm.handleCurrentPage
    }
  })], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('h4', {
    staticClass: "header-title m-b-20"
  }, [_vm._v("Liste des fiches")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e14c500"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents/Main/CustomersList.vue
// module id = 680
// module chunks = 1